import { render, staticRenderFns } from "./ZoneInfo.vue?vue&type=template&id=6833b997&scoped=true&"
import script from "./ZoneInfo.vue?vue&type=script&lang=js&"
export * from "./ZoneInfo.vue?vue&type=script&lang=js&"
import style0 from "./ZoneInfo.vue?vue&type=style&index=0&id=6833b997&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6833b997",
  null
  
)

export default component.exports